import {
    APPTOOLBAR_SWITCH_CLEAR_DIALOG_VISIBILITY,
    APPTOOLBAR_RESET_APP_STATE,
    LEGACY_COMPONENT_USER_DIALOG, MULTIBED_RESET_APP_STATE, APPTOOLBAR_SWITCH_CREATE_DIALOG_VISIBILITY, APPTOOLBAR_BASIC_RESET_APP_STATE,
} from "../lib/types";
import dataset from "../lib/datasets/dataset.json";

const initialState = {
    endcaps: dataset.elements.filter(e => e.type === "endcap"),
    chambers: dataset.elements.filter(e => e.type === "chamber"),
    accessories: dataset.elements.filter(e => e.type === "accessory"),
    pipeAccessories: dataset.elements.filter(e => e.type === "pipeAccessory"),
    showEraseDialog: false,
    showCreateDialog: false,
    showLogoutDialog: false,
    showLegacyComponentDialog: false,
};

export default (state = initialState, action) => {
    /* discriminate the action type */
    switch (action.type) {
        case APPTOOLBAR_SWITCH_CLEAR_DIALOG_VISIBILITY:
            return {
                ...state,
                showEraseDialog: action.payload,
            };

        case APPTOOLBAR_SWITCH_CREATE_DIALOG_VISIBILITY:
            return {
                ...state,
                showCreateDialog: action.payload,
            };

        case APPTOOLBAR_BASIC_RESET_APP_STATE:
        case MULTIBED_RESET_APP_STATE:
        case APPTOOLBAR_RESET_APP_STATE:
            return {
                ...state,
                showEraseDialog: initialState.showEraseDialog,
            };

        case LEGACY_COMPONENT_USER_DIALOG:
            return {
                ...state,
                showLegacyComponentDialog: action.payload.showDialog
            };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/apptoolbar-reducer.js